import { createQueryKeyStore } from '@lukemorales/query-key-factory'
import { AddressValidationRequest, GetDeltasParams, GetEngagementsParams, GetMediatorUrlParams, RecordingType, WorkflowStatus } from './models'
import { GetMediatorAccessTokenParams } from './api'

// if you prefer to declare everything in one file
export const keyStore = createQueryKeyStore({
  locations: {
    byId: (sid: string) => [sid],
    getSidBySystemNumber: (systemNumber: string) => [systemNumber],
    getSidByCameraId: (cameraId: string) => [cameraId],
    changes: (sid: string) => [sid],
    cameras: (sid: string) => [sid],
    safewords: (sid: string) => [sid],
    deltas: (sid: string, queryParams?: GetDeltasParams) => [sid, queryParams],
    securitasIdentifiers: (sid: string) => [sid],
    workFlowsByStatus: (locationId: string, workflowStatus: WorkflowStatus) => [locationId, workflowStatus]
  },
  mspLocation: {
    byId: (sid: string) => [sid]
  },
  permits: {
    notes: (sid: string) => [sid],
    history: (sid: string) => [sid]
  },
  locationAlarms: {
    all: (sid: string) => [sid],
    byId: (sid: string, alarmId: string) => [sid, alarmId],
    smsIncident: (sid: string, alarmId: string) => [sid, alarmId]
  },
  validatedAddresses: {
    byAddress: (sid: string, address: AddressValidationRequest) => [sid, ...Object.values(address)]
  },
  holodeck: {
    routingSchedule: () => ['all']
  },
  recordings: {
    segmentsByEngagementAndType: (engagementId: string, recordingType: RecordingType) => [engagementId, recordingType]
  },
  rrweb: {
    recording: (engagementId: string) => [engagementId],
    mediatorAccessToken: (params: GetMediatorAccessTokenParams) => [params.locationId, params.engagementId],
    recordingUrl: (params: GetMediatorUrlParams) => [params.locationId, params.engagementId, params.cameraId, params.start, params.end],
    streamingSessionUrl: (mediatorUrl: string) => [mediatorUrl]
  },
  moderationEvents: {
    all: (sid: string) => [sid]
  },
  practiceMode: {
    status: (sid: string) => [sid, 'status']
  },
  certificates: {
    byId: (sid: string) => [sid],
    email: (sid: string) => [sid, 'email']
  },
  engagements: {
    search: (queryParams?: GetEngagementsParams) => [
      'engagements',
      'search',
      queryParams?.locationId,
      queryParams?.interval,
      queryParams?.specialistId,
      queryParams?.limit,
      queryParams?.nextToken
    ],
    byId: (engagementId: string) => ['engagements', 'byId', engagementId],
    events: (engagementId: string) => ['engagements', 'events', engagementId],
    activities: (engagementId: string) => ['engagements', 'activities', engagementId],
    recordings: (params: GetMediatorAccessTokenParams) => [params.locationId, params.engagementId],
    cameraRecordings: (params: GetMediatorUrlParams) => [params.locationId, params.engagementId, params.cameraId, params.start, params.end]
  },
  specialists: {
    byId: (monitoringServiceProviderId: string, specialistId: string) => [monitoringServiceProviderId, specialistId]
  }
})
